import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const adminApi = createApi({
    reducerPath: 'adminApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_BACKEND_HOST}/api/admin`,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem('prona_userToken');
            if (token) headers.set('Authorization', `Bearer ${token}`);
            return headers;
        },
    }),
    tagTypes: ['Dashboard'],
    endpoints: (build) => ({
        getDashboardStats: build.query({
            query: (params = {}) => {
                const qs = new URLSearchParams(params).toString();
                return qs ? `/home-page?${qs}` : '/home-page';
            },
            providesTags: ['Dashboard'],
        }),
        getListingAudit: build.query({
            query: (listing_id) => `/listings/${listing_id}/audit`,
        }),
    }),
});

export const { useGetDashboardStatsQuery, useGetListingAuditQuery } = adminApi;
